import firebase from './../../../firebase';
import React from 'react';
import {    useNavigate } from 'react-router-dom'; 
import { Row, Col, Card, Badge , Alert} from 'react-bootstrap';   

const Dashboard = () => {
  const [data, setData] = React.useState([])
  const [l, setL] = React.useState(true); 
  const [isadmin, setAdmin] = React.useState(false)
  const navigate = useNavigate();
  
  const db = firebase.firestore();
  const [birthdays, setBirthdays] = React.useState([]);
 
  const loadList = () => {
    // get list clients and format
    firebase.firestore().collection('properties').get().then((snap)=> {
        let s = [];
        snap.forEach((d) => {  
            const dr = d.data()
            dr.id = d.id;
            if (dr?.delete){

            }else{
                s.push(dr)
            }
            
        })

        const ml = s.filter(propriete => {
          if (propriete?.isfavorite){
            return true
          }
          return false
        })

        setData(ml);
        
    }).catch((error) => {
        setL(false); 
        var errorMessage = error.message;
        toast.error(errorMessage);
    })
  }

  React.useEffect(()=> {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user)  {
        setL(false)
        loadList()
        const usess = await firebase.firestore().collection("users").doc(user.uid).get()
        
         if (usess && usess?.data().type === 'admin'){
          setAdmin(true); 
        }
      }else{
        navigate('/login');   
      }
      
    })
  }, [])

  
  React.useEffect(() => {
    const fetchBirthdays = async () => {
      const today = new Date();
      const todayStr = today.toISOString().slice(5, 10); // Format "MM-DD"

      try {
        const snapshot = await db.collection("crm").get();
        const birthdayClients = snapshot.docs
          .map((doc) => {
            const data = doc.data();
            if (data.birthday) {
              const birthYear = parseInt(data.birthday.split("-")[0], 10);
              const birthDate = data.birthday.slice(5, 10); // "MM-DD"

              if (birthDate === todayStr) {
                const age = today.getFullYear() - birthYear;
                return { id: doc.id, name: `${data.lastName} ${data.firstName}`, age };
              }
            }
            return null;
          })
          .filter((client) => client !== null);

        setBirthdays(birthdayClients);
      } catch (error) {
        console.error("Erreur lors de la récupération des anniversaires:", error);
      }
    };

    fetchBirthdays();
  }, []);

  const BlocRes = ({e}) => { 

    return (
        <div > 
                    <img src={e?.gallery?.length > 0  ? e?.gallery[0] :  ''} alt="pas d'image" style={{height:200, width:'100%', objectFit:'cover', borderRadius:20, border: '1px solid orange'}}/>
                          
                        <div style={{padding: 10}}>
                        <div style={{flexDirection: 'row', display: 'flex', justifyContent: 'space-between'}}>
                            <h5 >{e.nameHouse} - {e?.type?.label}</h5>
                            <a target="_blank" href={isadmin ?`/v/${e.id}`:`/vl/${e.id}`}>voir</a>
                        </div>
                        <p style={{fontSize:11}}>{e.description.substring(0,100)}...<br/>
                        <span style={{fontSize:14}}>{e.nbRooms} lits</span><br/>
                        <span style={{fontSize:14}}>{e.maxGuest} invités</span>
                        </p>
                        </div>
                        
                    </div>
    )
  }
  
  
  return (
    <>
    {!l && (<>
      <h1>Tableau de bord</h1>


      
      {birthdays.length > 0 && (
        <Alert variant="success">
        🎉 {birthdays.map((b, i) => (
          <><br/>
          <span key={b.id}> 
           <a href={`/crm/edit/${b.id}`}>{b.name}</a> fête ses {b.age} ans aujourd'hui ! 🎂
          </span>
          </>
        ))}
      </Alert>
      )}




      {/* {isadmin && (
        <><Card> 
        <Card.Body>
        
        <h3>Fabio home connexion <Badge bg="danger">Nouveau</Badge></h3> 
        <p>Connexion avec Fabio Home services et les villas correspondante.<br/><br/>
        Ajouter une connexion avec les villas de FHS depuis la liste des villas, <br/>connexion de l'identifiant de la villa avec l'identifiant de la connexion de Fabio Home avec l'API.</p>
        <p>Cliquer sur <b>FHS</b> et valider la connexion puis ouvrir la liste des <b>contacts</b> ou de la <b>fiche maisons</b>.</p>
        </Card.Body> 

        <Card.Body>
        
        <h3>Accès pour les équipes de ménage <Badge bg="warning">Nouveau</Badge></h3> 
        <p>Disponible dans le menu <b>Ménage</b>.<br/>
        Vous avez la possibilité de noter le temps de ménage nécessaire.<br/>
        L'employé pourra ajouter le calendrier de ménage sur son appareil.</p>
         </Card.Body> 
        
      </Card>
      <br/></>
      )} */}
    {/* 
    <p>Vous pouvez voir quelques element et a quoi pourra ressembler votre tableau de bord</p>
    <p><span>Pour la déconnexion, cliquer sur l'icon en haut a droite puis déconnexion.</span> Mais avant vous avez la possibilité aussi de changer le theme générale de votre back office.</p> */}
      <Row className="g-3 mb-3">
      {data?.map(e=>{
        return (
          <Col md={6} xxl={3}>
          <BlocRes e={e} />
          </Col>
        )
        
          })}
      </Row>
      
      {/* <Row className="g-3 mb-3">
        <Col md={6} xxl={3}>
          <WeeklySales data={weeklySalesData} />
        </Col>
        <Col md={6} xxl={3}>
          <TotalOrder data={totalOrder} />
        </Col>
        <Col md={6} xxl={3}>
          <MarketShare data={marketShare} radius={['100%', '87%']} />
        </Col>
        <Col md={6} xxl={3}>
          <Weather data={weather} />
        </Col>
      </Row>

      <Row className="g-3 mb-3">
        <Col lg={6}>
          <RunningProjects data={runningProjects} />
        </Col>
        <Col lg={6}>
          <TotalSales data={totalSales} />
        </Col>
      </Row>

      <Row className="g-3 mb-3">
        <Col lg={6} xl={7} xxl={8}>
          <StorageStatus className="h-lg-100" data={storageStatus} />
        </Col>
        <Col lg={6} xl={5} xxl={4}>
          <SpaceWarning />
        </Col>
      </Row>

      <Row className="g-3 mb-3">
        <Col lg={7} xl={8}>
          <BestSellingProducts products={products} />
        </Col>
        <Col lg={5} xl={4}>
          <SharedFiles files={files} className="h-lg-100" />
        </Col>
      </Row>

      <Row className="g-3">
        <Col sm={6} xxl={3}>
          <ActiveUsers className="h-100" users={users} />
        </Col>
        <Col sm={6} xxl={3} className="order-xxl-1">
          <BandwidthSaved />
        </Col>
        <Col xxl={6}>
          <TopProducts data={topProducts} className="h-100" />
        </Col>
      </Row> */}
    </>)}
    </>
  );
};

export default Dashboard;
